import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Box, FileDrop, Text } from '@maui/elements'
import { uploadFiles } from '../../../api'
import { useEodDrawer } from '../../../providers/EodDrawerContext'

export const FileAttachments = ({ onDropSuccess, onFileRemoved }) => {
  const { maApiHost, authenticatedFetch } = useEodDrawer()
  const postFiles = useCallback((files) => {
    uploadFiles(files, maApiHost, authenticatedFetch).then(res => {
      onDropSuccess(res)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onDrop = useCallback(async (files) => {
    if (files.length === 0) return
    postFiles(files)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnRemove = useCallback((file, files) => {
    if (onFileRemoved) {
      onFileRemoved(file, files)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box mb="spaceGapXLarge">
      <Box mb="spaceGapMedium">
        <Text variant="heading5" as='label' htmlFor='attachmentInput'>
          Add Attachment(s)
        </Text>
      </Box>
      <Text variant="body2" mb="spaceGapXLarge">
        File size may not exceed 10mb. Click the field below to add additional files.
      </Text>
      <FileDrop id='attachmentInput' name='file' onDrop={onDrop} onRemove={handleOnRemove} noClick={false} noKeyboard={false}/>
    </Box>
  )
}

FileAttachments.propTypes = {
  onDropSuccess: PropTypes.func.isRequired,
  onFileRemoved: PropTypes.func
}

export default FileAttachments
